import React from 'react';
import { useHistory } from 'react-router-dom';
import { HeaderSearchProps } from './HeaderSearch.types';
import { getAppEnv } from '../../../../../../../config/env';
import { IMAGE_ALT_TEXT } from '../../../../constants/LTSConstants';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const HeaderSearch = (props: HeaderSearchProps) => {
  const { placeholder, value, buttonLabel, onChange, onButtonClick } = props;
  const history = useHistory();

  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <div className="LTSTrainNumber-HeaderSearch-wrapper">
      <div className="LTSTrainNumber-HeaderSearch-back-arrow" onClick={handleBackClick}>
        <img src={`${PUBLIC_URL}/static/public/ic_back_arrow.webp`} alt={IMAGE_ALT_TEXT.backArrow} />
      </div>
      <div className="LTSTrainNumber-HeaderSearch-input-control">
        <input type="text" autoFocus value={value} placeholder={placeholder} onChange={onChange} />
        <button className="LTSTrainNumber-HeaderSearch-btn LTSPageCommon-click-transition" onClick={onButtonClick}>
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default HeaderSearch;
